export const cellPosts = {
  'padding-top': 12,
}

export const cellPostsSmall = {
  'padding-top': 10,
}

export const dateStyle = {
  position: 'absolute',
  color: 'black',
  top: -4,
  right: 0,
  fontSize: 15,
};

export const dateStyleSmall = {
  position: 'absolute',
  color: 'black',
  top: -4,
  right: 0,
  fontSize: 12,
};

export const cellStyle = {
  height: 63,
  width: 63,
  position: 'relative',
  background: 'lightgray',
};

export const cellStyleSmall = {
  height: 40,
  width: 40,
  position: 'relative',
  background: 'lightgray',
};

export const getHalfCell = (color) => {
  return {
    background: color,
    'margin-top': '2px',
    width: 32,
    height: 8,
  };
};

export const getHalfCellSmall = (color) => {
  return {
    background: color,
    'margin-top': '2px',
    width: 20,
    height: 5,
  };
};

export const getFullCell = (color) => {
  return {
    background: color,
    'margin-top': '2px',
    width: 63,
    height: 8,
  };
};

export const getFullCellSmall = (color) => {
  return {
    background: color,
    'margin-top': '2px',
    width: 40,
    height: 5,
  };
};



// WEBPACK FOOTER //
// ./src/screens/Organic/CalendarComponents.js